window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slider').forEach(gallery => {
    const swiper = gallery.querySelector('.swiper');
    const pagination = gallery.querySelector('.__pagination');
    const duration = (pagination.style.getPropertyValue('--duration')) ? parseInt(pagination.style.getPropertyValue('--duration')) * 1000 : 0;
    const autoPlay = (duration > 0) ? {
      delay: duration,
      disableOnInteraction: false,
    } : false;
    const slider = new Swiper(swiper, {
      parallax: true,
      speed: 800,
      loop: true,
      autoplay: autoPlay,
      pagination: {
        el: gallery.querySelector('.__pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: gallery.querySelector('.swiper-button-next'),
        prevEl: gallery.querySelector('.swiper-button-prev'),
      },
    });
  })

});


window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-gallery').forEach(gallery => {
    const swiper = gallery.querySelector('.swiper');
    const isParallax = swiper.querySelectorAll('[data-swiper-parallax-x]').length > 0;
    const slider = new Swiper(swiper, {
      speed: 800,
      loop: true,
      parallax: isParallax,
      effect: isParallax ? '' : 'fade',
      navigation: {
        nextEl: gallery.querySelector('.swiper-button-next'),
        prevEl: gallery.querySelector('.swiper-button-prev'),
      }
    });

    const navItems = gallery.querySelectorAll('.__indices ul li a');
    navItems.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        slider.slideToLoop(index);
      });
    });

    const desc = gallery.querySelector('.__desc');
    if (desc) {
      const descItems = desc.querySelectorAll('div[data-index]');
      slider.on('slideChange', () => {
        const realIndex = slider.realIndex;
        descItems.forEach(item => item.style.display = 'none');
        descItems[realIndex].style.display = 'block';
      });
    }

    slider.on('slideChange', () => {
      const realIndex = slider.realIndex;
      navItems.forEach(item => item.classList.remove('--active'));
      navItems[realIndex].classList.add('--active');
      const video = slider.slides[slider.activeIndex].querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play();
      }
    });

    navItems[0].classList.add('--active');
  })

});

